import { IMember } from "../types/interfaces/IMember";

/**
 * SortMembers Hook
 * 
 * This custom hook sorts an array of IMember objects by their lastName property in ascending order.
 * It uses the JavaScript Array.prototype.sort() function to perform the sorting.
 * If a lastName is null or undefined, it is treated as an empty string.
 * The comparison is done lexicographically using the localeCompare() method.
 * 
 * @param {IMember[]} members - The array of IMember objects to be sorted.
 * @returns {IMember[]} The sorted array of IMember objects.
 * 
 * Example usage:
 * ```tsx
 * const sortedMembers = SortMembers(members);
 * ```
 */
export default function SortMembers(members: IMember[]): IMember[] {
    return members.sort((object1: IMember, object2: IMember) => {
        const lastName1 = object1.LastName ?? "";
        const lastName2 = object2.LastName ?? "";
        return lastName1.localeCompare(lastName2);
    });
};